export enum EstoqueTypes {
  'LOAD_REQUEST' = '@estoque/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@estoque/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@estoque/LOAD_FAILURE',

  'FILTER_ESTOQUE' = '@estoque/FILTER_ESTOQUE',

  'SORTER_ESTOQUE' = '@estoque/SORTER_ESTOQUE',

  'COD_PARCEIRO' = '@estoque/COD_PARCEIRO',

  'CLEAN_ESTOQUE' = '@estoque/CLEAN_ESTOQUE',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IEstoque {
  numNota: number;
  nuNota: number;
  nuCobertura?: number;
  codParceiro: number | any;
  nomeParceiro: string;
  pagador: string;
  codProduto: number;
  codPagador: number;
  descricaoProduto: string;
  controle: string;
  disponivelDepositante: number;
  disponivelFornecedor: number;
  disponivel: number;
  total: number;
  codInterno: string;
  codReferencia: string;
  unidade: string;
  pendenciaCobertura: string;
  siglaUnidade: string;
  parceiro: string;
  produto: string;
  cnpjCpfParceiro: string;
  necessitaCobertura: boolean;
  cobertura: boolean;
  cnpjCpfPagador: string;
  inscricaoEstadualParceiro: string;
  inscricaoEstadualPagador: string;
  reservado: number;
  numcontrato: number;
  dtValidade: string | undefined;
}

export interface IEstoqueModal {
  codParceiro: number;
  nomeParceiro: string;
  codProduto: number;
  descricaoProduto: string;
  controle: string;
  disponivelDepositante: number;
  disponivelFornecedor: number;
  indisponivelDepositante: number;
  indisponivelFornecedor: number;
  reservadoDepositante: number;
  reservadoFornecedor: number;
  total: number;
  codInterno: string;
  codReferencia: string;
  unidade: string;
  pendenciaCobertura: string;
}

export interface IFiltroEstoque {
  produto: string;

  codCentroDistribuicao: number;
  pagadorArmazenagem: string;
  proprietarioMercadoria: string;
  nfVenda: number;
  nfRemessa: number;
  controle: string;
  situacaoFiscalProduto: string;
  situacaoProduto: string;
  diasParaVencer: number;
  grupoResponsavel: string;
  codParceiro: number;
}

export interface IFilter {
  filter: object | undefined;
  codParceiro: number;
}

export interface ICodParceiro {
  codParceiro: number | any;
}

export interface EstoqueState {
  readonly data: IEstoque[];
  readonly loading: boolean;
  readonly loadingDetalhes: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
  readonly filter?: IFilter;
  readonly sorter?: any;
  readonly codParceiro?: ICodParceiro | any;
}
